import { useState, useEffect } from "react";
import { useMediaQuery } from "@mui/material"
import { useParams, useLocation } from 'react-router-dom'
import FaqMobList from "./FaqMobList";
import FaqWebList from "./FaqWebList";


export default function FaqList() {
    const isSmallScreen = useMediaQuery('(max-width:400px)')
    const { categoryName } = useParams()
    const location = useLocation()
    const [categoryId, setCategoryId] = useState(null)
    const searchCategoryId = location.state?.searchCategoryId
    const searchSubCategoryId = location.state?.searchSubCategoryId
    const searchFaqId = location.state?.searchFaqId

    useEffect(() => {

        const stateCategoryId = location.state?.categoryId;

        if (stateCategoryId) {
            localStorage.setItem("categoryId", stateCategoryId);
            setCategoryId(stateCategoryId);
        } else {
            const storedCategoryId = localStorage.getItem("categoryId");
            if (storedCategoryId) {
                setCategoryId(storedCategoryId);
            }
        }

    }, [location.state])
    return (<main>
        {/* {isSmallScreen ?
            <FaqMobList /> : */}
             <FaqWebList
                categoryId={categoryId}
                categoryName={categoryName}
                searchCategoryId={searchCategoryId}
                searchSubCategoryId={searchSubCategoryId}
                searchFaqId={searchFaqId}
             />
        {/* } */}
    </main>)
}
